module.exports = __webpack_public_path__ + "img/Email _ Phone.6204edf4.svg";